var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('hr',{staticClass:"w-full border-grey"}),_c('div',{staticClass:"flex"},[_c('span',{staticClass:"text-base text-cta-lt mt-4 cursor-pointer hover:underline",on:{"click":_vm.ctaAction}},[_vm._v(" "+_vm._s(_vm.$t(_vm.ctaTitle))+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }